import { TrainingModel } from '@modules/training/training-model';

const { fields } = TrainingModel;

export default [
  fields.id,
  fields.title,
  fields.description,
  fields.date,
  fields.hour,
  fields.duration,
  fields.location,
  fields.status,
  fields.team,
  fields.createdAt
];
